import { Component, Input, OnInit } from '@angular/core';

const CartStatusMapper = {
  'OPEN': {
    label: 'IN PROGRESS',
    styleClass: 'in-progress'
  },
  'COMPLETE': {
    label: 'COMPLETED',
    styleClass: 'completed'
  },
  'COMPLETED': {
    label: 'COMPLETED',
    styleClass: 'completed'
  }
}

@Component({
  standalone: true,
  selector: 'equine-ui-nx-cart-status',
  templateUrl: './cart-status.component.html',
  styleUrls: ['./cart-status.component.scss']
})
export class CartStatusComponent implements OnInit {

  @Input() status!: string;

  public label = '';
  public styleClass = '';

  ngOnInit(): void {
    if (this.status === 'OPEN' || this.status === 'COMPLETE' || this.status === 'COMPLETED') {
      this.label = CartStatusMapper[this.status].label;
      this.styleClass = CartStatusMapper[this.status].styleClass;
    } else {
      this.label = this.status;
      this.styleClass = ''
    }
  }

}
